import React from 'react';
import { NavBarTrigger, NavBarTriggerProps } from './NavBarTrigger';

export const HomePageNavBarTrigger = (props: NavBarTriggerProps) => (
  <NavBarTrigger type="homepage" {...props} />
);
